import * as React from 'react';

import { Col } from '@rematter/ui-web';

export interface EmptyDetailStateProps {
  icon: React.ReactElement<{
    size?: number | string;
    className?: string;
  }>;
  title: string;
  subtitle: string;
}

export const EmptyDetailState: React.FC<EmptyDetailStateProps> = ({
  icon,
  title,
  subtitle,
}) => (
  <Col className="@EmptyDetailState h-full items-center justify-center">
    {React.cloneElement(icon, {
      size: 48,
      className: 'text-neutral/20',
    })}
    <span className="mt-4 text-lg font-medium text-neutral/50">{title}</span>
    <span className="text-sm text-neutral/40">{subtitle}</span>
  </Col>
);
